(ns app.front.ui.v2.status-tag
  (:require [app.front.ui.status :as ui-status]))

(defn tag
  "Tag component to indicate status with color and text
  `status`: keyword to match colors defined in app.front.ui.status"
  [{:keys [status]} & children]
  (into [:span.inline-flex.flex-none.self-auto.h-fit.rounded-full.px-3.py-1.text-xs.uppercase
         {:class [(ui-status/status->bg-text-color-classes status)]}]
        children))
